const RightTickIcon = ({
  iconVariant = "default",
  iconColor = "primary-700",
}) => {
  if (iconVariant === "rounded") {
    return (
      <svg width="12" height="11" viewBox="0 0 12 11" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7464 0.274437L3.58641 7.18444L1.68641 5.15444C1.33641 4.82444 0.786406 4.80444 0.386406 5.08444C-0.00359413 5.37444 -0.113594 5.88444 0.126406 6.29444L2.37641 9.95444C2.59641 10.2944 2.97641 10.5044 3.40641 10.5044C3.81641 10.5044 4.20641 10.2944 4.42641 9.95444C4.78641 9.48444 11.6564 1.29444 11.6564 1.29444C12.5564 0.374437 11.4664 -0.435563 10.7464 0.264437V0.274437Z"
          fill={`var(--bs-${iconColor})`}
        />
      </svg>
    );
  }

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M13.7295 2.49669L5.1222 12.8254L0.330078 7.8964L2.00307 6.26989L4.98872 9.34084L11.937 1.00293L13.7295 2.49669Z"
        fill={`var(--bs-${iconColor})`}
      />
    </svg>
  );
};

export default RightTickIcon;
